export class FileModel {
  id: string;
  file: string;

  constructor({ id, file }: { id: string; file: string }) {
    this.id = id;
    this.file = file;
  }
}
